import Components from 'views/Components/Components.jsx';
import CustomerDashboard from 'views/User/index.jsx';
import ProviderDashboard from 'views/User/index.jsx';

import ServiceListNew from 'views/User/index.jsx';
import TaskListNew from 'views/User/index.jsx';
import BookingConfirmNew2 from 'views/User/index.jsx';

import BookingScheduleNew from 'views/User/index.jsx';
import Rebook from 'views/User/index.jsx';
import Reshedule from 'views/User/index.jsx';
import AdditionalInfoNew from 'views/User/index.jsx';
import ConfirmBookingNew from 'views/User/index.jsx';
import BookingSuccess from 'views/User/index.jsx';
import ManageBookings from 'views/User/index.jsx';
import ManageBookingsCategory from 'views/User/index.jsx';
import BookingsDetails from 'views/User/index.jsx';
import ViewAdditionalInfoNew from 'views/User/index.jsx';
import ProviderInfoNew from 'views/User/index.jsx';
import BookingApproval from 'views/User/index.jsx';
import BookingRejection from 'views/User/index.jsx';
import RevisePriceRequest from 'views/User/index.jsx';
import ReferFriend from 'views/User/index.jsx';
import UserTutorials from 'views/User/index.jsx';

import CustomerProfile from 'views/User/index.jsx';
import InitialProfile from 'views/User/index.jsx';
// import InitialProfile from 'views/User/InitialProfile';
// import CustomerProfile from '../views/User/Profile.jsx';
import CustomerAddress from 'views/User/index.jsx';
import AddressCreate from 'views/User/index.jsx';
import BookingList from 'views/User/index.jsx';
import TodaysBookingList from 'views/User/index.jsx';
import TodayBookingDetails from 'views/User/index.jsx';
import BookingReschedule from 'views/User/index.jsx';
import BookingComplete from 'views/User/index.jsx';
import ProposeNewPrice from 'views/User/index.jsx';

import FavouriteExpansion from 'views/User/index.jsx';
import ChangePassword from 'views/User/index.jsx';
import Inbox from 'views/User/index.jsx';
import AddressUpdate from 'views/User/index.jsx';
import ServiceList from 'views/User/index.jsx';
import ProviderList from '../views/User/ProviderListing.jsx';
import ProviderDetail from '../views/User/ProviderDetail.jsx';
import CategoryService from '../views/Category/ServiceListing.jsx';
import MainSearch from '../views/Category/MainSearch.jsx';
import Signup from '../views/Signup/SignupStepper.jsx';
import BookingCreate from '../views/Booking/Create.jsx';
import BookingPayment from '../views/Booking/Payment.jsx';
import BookingStatus from '../views/Booking/Status.jsx';
import NotificationList from 'views/User/index.jsx';
import PromocodeList from 'views/User/index.jsx';
import ChatPanel from 'views/User/index.jsx';
import NotAllowed from '../views/NotAllowed.jsx';
import Maintainence from '../views/Maintainence.jsx';
import Page from '../views/Page/Detail.jsx';
import Contact from '../views/Page/Contact.jsx';
import SigninForm from '../views/LoginPage/SigninForm';
import SosList from 'views/User/index.jsx';
import ReferList from 'views/User/index.jsx';
import BookingCalendarList from 'views/User/index.jsx';
import Help from 'views/User/index.jsx';
import MaintenanceList from 'views/User/index.jsx';
import RecurringBookingList from 'views/User/index.jsx';
import ManageEmployeesList from 'views/User/index.jsx';
import ReviewList from 'views/User/index.jsx';
import HolidayList from 'views/User/index.jsx';
import BlockedList from 'views/User/index.jsx';




var indexRoutes = [
    //User Routes
    {// route added for initial profile By Pooja on 17/11/22
        path: '/user/profile/initial',
        name: 'InitialProfile',
        component: InitialProfile,
        exact:true
    },
    {
        path: '/user/services/',
        name: 'ServiceListNew',
        component: ServiceListNew
    },
    {
        path: '/user/tasks',
        name: 'TaskListNew',
        component: TaskListNew
    },
    {
        path: '/user/booking_confirm',
        name: 'BookingConfirmNew2',
        component: BookingConfirmNew2
    },
    {
        path: '/user/booking_schedule',
        name: 'BookingScheduleNew',
        component: BookingScheduleNew
    },
    {
        path: '/user/rebook',
        name: 'Rebook',
        component: Rebook
    },
    {
        path: '/user/reschedule',
        name: 'Reshedule',
        component: Reshedule
    },
    {
        path: '/user/additional_info',
        name: 'AdditionalInfoNew',
        component: AdditionalInfoNew
    },
    {
        path: '/user/provider_info',
        name: 'ProviderInfoNew',
        component: ProviderInfoNew
    },
    {
        path: '/user/confirm_booking',
        name: 'ConfirmBookingNew',
        component: ConfirmBookingNew
    },
    {
        path: '/user/booking_success',
        name: 'BookingSuccess',
        component: BookingSuccess
    },
    {
        path: '/user/manage_bookings',
        name: 'ManageBookings',
        component: ManageBookings
    },
    {
        path: '/user/bookings_list',
        name: 'ManageBookingsCategory',
        component: ManageBookingsCategory
    },
    {
        path: '/user/bookings_details',
        name: 'BookingsDetails',
        component: BookingsDetails
    },
    {
        path: '/user/view_additional_info',
        name: 'ViewAdditionalInfoNew',
        component: ViewAdditionalInfoNew
    },
    {
        path: '/user/booking_approval',
        name: 'BookingApproval',
        component: BookingApproval
    },
    {
        path: '/user/booking_rejection',
        name: 'BookingRejection',
        component: BookingRejection
    },
    {
        path: '/user/revise_price_request',
        name: 'RevisePriceRequest',
        component: RevisePriceRequest
    },
    {
        path: '/user/refer_friend',
        name: 'ReferFriend',
        component: ReferFriend
    },
    {
        path: '/user/tutorials',
        name: 'UserTutorials',
        component: UserTutorials
    },
    {
        path: '/user/dashboard',
        name: 'CustomerDashboard',
        component: CustomerDashboard
    },
    {
        path: '/provider/dashboard',
        name: 'ProviderDashboard',
        component: ProviderDashboard
    },
    {
        path: '/user/profile',
        name: 'CustomerProfile',
        component: CustomerProfile
    },  
    {
        path: '/user/address',
        name: 'CustomerAddress',
        component: CustomerAddress
    },
    {
        path: '/address/create',
        name: 'AddressCreate',
        component: AddressCreate
    },
    // {
    //     path: '/provider-service/create',
    //     name: 'ProviderServiceCreate',
    //     component: ProviderServiceCreate
    // },
    {
        path: '/user/booking',
        name: 'BookingList',
        component: BookingList
    },
    {
        path: '/provider/service',
        name: 'ServiceList',
        component: ServiceList
    },
    {
        path: '/employees',
        name: 'ManageEmployee',
        component: ManageEmployeesList
    },
    // {
    //     path: '/provider/booking',
    //     name: 'BookingList',
    //     component: BookingList
    // },
    {
        path: '/provider/manage_bookings',
        name: 'BookingList',
        component: BookingList
    },
    {
        path: '/provider/manage_todays_bookings',
        name: 'TodaysBookingList',
        component: TodaysBookingList
    },
    {
        path: '/provider/booking/:id',
        name: 'BookingList',
        component: BookingList
    },
    {
        path: '/provider/booking_today/:id',
        name: 'TodayBookingDetails',
        component: TodayBookingDetails
    },
    {
        path: '/provider/booking_reschedule/:id',
        name: 'BookingReschedule',
        component: BookingReschedule
    },
    {
        path: '/provider/booking_complete/:id',
        name: 'BookingComplete',
        component: BookingComplete
    },
    {
        path: '/provider/propose_new_price/:id',
        name: 'ProposeNewPrice',
        component: ProposeNewPrice
    },
    // {
    //     path: '/provider/pendingbooking',
    //     name: 'BookingList',
    //     component: BookingList
    // },
    {
        path: '/user/favourite',
        name: 'FavouriteList',
        component: FavouriteExpansion
    },

    {
        path: '/provider/list/:keyword/:city/:category',
        name: 'ProviderList',
        component: ProviderList
    },
    {
        path: '/provider/list/:service',
        name: 'ProviderList',
        component: ProviderList
    },
    {
        path: '/provider/category/:category',
        name: 'ProviderList',
        component: ProviderList
    },
    // {
    //     path: '/provider/all/:serviceId',
    //     name: 'ProviderList',
    //     component: ProviderList
    // },
    {
        path: '/provider/list/:city',
        name: 'ProviderList',
        component: ProviderList
    },
    {
        path: '/provider/list',
        name: 'ProviderList',
        component: ProviderList
    },
    {
        path: '/provider/detail/:providerId/:serviceId',
        name: 'ProviderDetail',
        component: ProviderDetail
    },
    {
        path: '/category/services',
        name: 'CategoryServices',
        component: CategoryService
    },
    {
        path: '/mainsearch',
        name: 'MainSearch',
        component: MainSearch
    },
    {
        path: '/signup',
        name: 'Signup',
        component: Signup
    },
    {
        path: '/Become',
        name: 'Become',
        component: Signup 
    },
    {
        path: '/book/service/:providerId/:serviceId/:itemId',
        name: 'BookingCreate',
        component: BookingCreate
    },
    {
        path: '/book/service/:providerId/:serviceId',
        name: 'BookingCreate',
        component: BookingCreate
    },
    {
        path: '/book/service/:providerId/',
        name: 'BookingCreate',
        component: BookingCreate
    },
    {
        path: '/booking/payment/',
        name: 'BookingPayment',
        component: BookingPayment
    },
    {
        path: '/booking/status/',
        name: 'BookingStatus',
        component: BookingStatus
    },
    {
        path: '/address/update/:addressId',
        name: 'AddressUpdate',
        component: AddressUpdate
    },
    {
        path: '/user/chat',
        name: 'ChatPanel',
        component: ChatPanel
    },
    // {
    //     path: '/booking/detail/:bookingId',
    //     name: 'BookingDetail',
    //     component: BookingDetail
    // },
    {
        path: '/notification/list',
        name: 'NotificationList',
        component: NotificationList
    },
    {
        path: '/blockprovider',
        name: 'Blocked Providers',
        component: BlockedList
    },
    {
        path: '/user/signin',
        name: 'SigninForm',
        component: SigninForm
    },

    {
        path: '/sos',
        name: 'SOS',
        component: SosList
    },
    {
        path: '/refer',
        name: 'Refer and Earn',
        component: ReferList
    },
    {
        path: '/maintenancelog',
        name: 'Maintenance Log',
        component: MaintenanceList
    },
    {
        path: '/bookingcalendar',
        name: 'Booking Calendar',
        component: BookingCalendarList
    },
    {
        path: '/recurringbookings',
        name: 'Recurring Bookings',
        component: RecurringBookingList
    },
    {
        path: '/help',
        name: 'Help',
        component: Help
    },
    {
        path: '/promocode/list',
        name: 'PromocodeList',
        component: PromocodeList
    },
    {
        path: '/user/changepassword',
        name: 'ChangePassword',
        component: ChangePassword
    },
    {
        path: '/user/inbox',
        name: 'Inbox',
        component: Inbox
    },

    {
        path: '/page/:slug',
        name: 'Page',
        component: Page
    },
    {
        path: '/contact-us',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/403',
        name: 'NotAllowed',
        component: NotAllowed
    },
    {
        path: '/maintainence',
        name: 'Maintainence',
        component: Maintainence
    },
    {
        path: '/review',
        name: 'Review and Rating',
        component: ReviewList
    },
    {
        path: '/holiday',
        name: 'Holidays',
        component: HolidayList
    },


    //    { path: '/ods', name: 'Components', component: Components, exact: true }
    { path: '/', name: 'Components', component: SigninForm, exact: true }
    // { path: '/', name: 'Components', component: Components, exact: true }
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx